import { h, Component } from 'preact';
import { track } from 'utils/tracking';
import pure from 'utils/pure';
import s from 'components/shared/expander/expander.sss';
import { joinClasses } from 'utils/utils';

export default @pure class Expander extends Component {

	constructor(props) {
		super(props);
		this.state.expanded = 0;
		this.toggleExpanded = this.toggleExpanded.bind(this);
		this.trackClicks = this.trackClicks.bind(this);
	}

	toggleExpanded() {
		let value = 0;
		if (!this.state.expanded && this.$childWrapper) {
			let previousMaxHeight = this.$childWrapper.style.maxHeight;
			this.$childWrapper.style.transition = 'none';
			this.$childWrapper.style.maxHeight = 'none';
			value = this.$childWrapper.clientHeight;
			this.$childWrapper.style.maxHeight = previousMaxHeight;
			// Trigger another rerender
			this.$childWrapper.clientHeight;
			this.$childWrapper.style.transition = '';
		}
		if (value !== this.state.expanded) {
			this.setState({ expanded: value });
		}
	}

	trackClicks() {
		track({ a: 'expander' });
	}

	render(props) {
		const {
			linkList,
			buttonText,
			titleClass
		} = props;

		let childStyle = {
			maxHeight: this.state.expanded + 'px'
		};
		return (
			<div class={joinClasses(s.expander, this.state.expanded && s.open)}>
				<div class={s.expandWrapper}>
					<h2 class={joinClasses(s.prompt, titleClass)} onClick={this.toggleExpanded}>{buttonText}</h2>
					<ol class={s.childWrapper} onClick={this.trackClicks} style={childStyle} ref={e => e && (this.$childWrapper = e)}>
						{linkList}
					</ol>
				</div>
			</div>
		);
	}

}
